import React from 'react'
import PropTypes from 'prop-types'
import sourceArticle from './VVP special Vijf vragen aan Bianca de Graaff.pdf'
import cover from './cover.jpg'

export default class Article extends React.Component {
  render() {
    return (
      <div className="Main">
        <div className="inner">
          <a href={sourceArticle} className="Article-link">
            <img
              target="_blank"
              src={cover}
              alt="VVP special Vijf vragen aan Bianca de Graaff cover"
            />
            <span>
              <span className="Article-linkHeader">
                Lees het interview van VVP »
              </span>
              <span className="Article-linkDescription">
                Inspiratiemagazine voor financieel advies
              </span>
            </span>
          </a>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Article.js